import React from 'react'
import {
  isCreatorConferencePromo,
  isExhibitorConferencePromo,
  isPageConferencePromo,
  isSessionConferencePromo,
} from '../helpers'
import StructuredData from './StructuredData'
import {
  getExhibitorListItemData,
  getListItemData,
  getSpeakerListItemData,
  getPageListItemData,
} from './ListItemStructuredData'

export const getItemListData = (items, name = undefined) => {
  const itemListElement = []
  const onlySessions = items.every(isSessionConferencePromo)
  const onlySpeakers = items.every(isCreatorConferencePromo)
  const onlyExhibitors = items.every(isExhibitorConferencePromo)
  const onlyPages = items.every(isPageConferencePromo)
  if (onlySessions) {
    itemListElement.push(...items.map((session, index) => getListItemData(session, index)))
  } else if (onlySpeakers) {
    itemListElement.push(...items.map((speaker, index) => getSpeakerListItemData(speaker, index)))
  } else if (onlyExhibitors) {
    itemListElement.push(...items.map((exhibitor, index) => getExhibitorListItemData(exhibitor, index)))
  } else if (onlyPages) {
    itemListElement.push(...items.map((page, index) => getPageListItemData(page, index)))
  }

  return {
    '@type': 'ItemList',
    name: name || undefined,
    itemListElement,
  }
}

export default function ItemListStructuredData({ data }) {
  if (!data || data.length === 0) return null
  const structuredData = getItemListData(data)

  return <StructuredData data={structuredData} dataTestId="item-list-structured-data" />
}
